/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum V2PaymentOption {
    NEXT_INSTALLMENT = 'next_installment',
    PAY_BALANCE = 'pay_balance',
    PAST_DUE = 'past_due',
}
